<template>
  <v-dialog v-model="display" width="500px">
    <template #activator="{on}">
      <v-btn outlined v-on="on">
        <v-icon left>mdi-plus</v-icon>Add Products
      </v-btn>
    </template>
    <v-form ref="form" v-model="form" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">Add Products</span>
        </v-card-title>
        <v-card-text v-if="!loading">
          <v-tabs v-model="tabs">
            <v-tab key="1" ripple>Single Product</v-tab>
            <v-tab key="2" ripple>Sets</v-tab>
            <v-tabs-items v-model="tabs" class="white elevation-1">
              <v-tab-item key="1">
                <v-card class="pa-3">
                  <v-layout wrap>
                    <v-flex xs12 md12>
                      <product-type-select :shop="this.shopId" v-model="typeId"></product-type-select>
                    </v-flex>
                    <v-flex xs12 md12>
                      <product-autocomplete
                        label="Product"
                        v-model="model.productId"
                        :filters="{
                          classification: typeId,
                          catalogId: this.catalogId,
                        }"
                        :disabled="!this.typeId"
                      ></product-autocomplete>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-text-field v-model="model.quantity" label="Quantity"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="add">Add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
              <v-tab-item key="2">
                <v-card class="pa-3">
                  <v-layout wrap>
                    <v-flex xs12 md12>
                      <product-type-select :shop="this.shopId" v-model="typeId"></product-type-select>
                    </v-flex>
                    <v-flex xs12 md12>
                      <set-autocomplete
                        label="Product"
                        v-model="model.productsId"
                        :filters="{
                          classification: typeId,
                          shopId: this.shopId,
                        }"
                        :disabled="!this.typeId"
                      ></set-autocomplete>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-text-field v-model="model.quantity" label="Quantity"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="addSet">Add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>
        <v-card-text v-else align-center justify-center column fill-height>
          <v-progress-circular :size="70" :width="7" indeterminate color="error"></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ProductAutocomplete from "@components/forms/autocomplete/Product.vue";
import SetAutocomplete from "@components/forms/autocomplete/Set.vue";
import ProductTypeSelect from "@components/forms/select/ProductType.vue";
import { mapActions } from 'vuex';
function getDefaultData() {
  return {
    loading: false,
    display: this.open,
    form: null,
    model: {
      productId: null,
      productsId: null,
      quantity: 1
    },
    typeId: null,
    tabs: null
  };
}
export default {
  components: {
    ProductTypeSelect,
    ProductAutocomplete,
    SetAutocomplete
  },
  data: getDefaultData,
  props: {
    open: {
      type: Boolean
    },
    shopId: {
      type: Number
    },
    catalogId: {
      type: Number
    },
    orderId: {
      type: Number
    }
  },
  methods: {
    ...mapActions('orders', ['addProduct', 'addProducts']),
    add: function() {
      if (this.model.productId && this.model.quantity) {
        this.loading = true;
        this.addProduct({
            orderId: this.orderId,
            model: this.model
          })
          .then(result => {
            this.resetForm();
            this.$emit("added", result);
            this.flashMessage.success({
              message: "Product added successfully",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    addSet: function() {
      if (this.model.productsId && this.model.quantity) {
        this.loading = true;
        this.addProducts({
            orderId: this.orderId,
            model: this.model
          })
          .then(result => {
            this.resetForm();
            this.$emit("added", result);
            this.flashMessage.success({
              message: "Products added successfully",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    resetForm() {
      this.model.productId = null;
      this.model.quantity = 1;
      this.typeId = null;
      this.$refs.form.reset();
    }
  },
  computed: {
    rules: function() {
      return {
        required: value => !!value || "This field is mandatory.",
        notHeadOnlyRequired: value => {
          if (this.model.headOnly) return true;
          return !!value || "This field is mandatory.";
        }
      };
    }
  },
  watch: {
    open: function() {
      this.display = this.open;
    },
    display: function() {
      this.$emit("update:open", this.display);
    }
  }
};
</script>

<style></style>
